"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BASE_PATH = void 0;
/* istanbul ignore file */ const BASE_PATH = exports.BASE_PATH = '/mypages/business-tools/share-and-earn/personal-products-lists';
